export default __webpack_public_path__ + "static/media/ml.0ac683aa.svg";